const colors = {
  light: {
    windowHeader: 'red',
    windowBody: 'green',
  },
  dark: {
    windowHeader: 'red',
    windowBody: '#5a5a5a',
  },
};

class Theme {
  constructor() {
    this.style = 'light';
  }

  change(style = 'light') {
    this.style = style;
  }

  getWindowBodyColor() {
    return colors[this.style].windowBody;
  }
}

export default new Theme();
